import {
  NAMESPACE_FAVORITES,
  NAMESPACE_INTERESTING_MATCHES,
  NAMESPACE_LIVE,
  NAMESPACE_PREMATCH,
} from 'app/constants/Context';

export const SET_LIVE_GRID_STAKE_TYPES = 'GRID:SET_LIVE_GRID_STAKE_TYPES';
export const SET_PREMATCH_GRID_STAKE_TYPES = 'GRID:SET_PREMATCH_GRID_STAKE_TYPES';
export const SET_PREMATCH_FAVORITES_GRID_STAKE_TYPES = 'GRID:SET_PREMATCH_FAVORITES_GRID_STAKE_TYPES';
export const SET_INTERESTING_MATCHES_GRID_STAKE_TYPES = 'GRID:SET_INTERESTING_MATCHES_GRID_STAKE_TYPES';

export const SET_LIVE_GRID_ORDER_KEY = 'GRID:SET_LIVE_ORDER_KEY';
export const SET_PREMATCH_GRID_ORDER_KEY = 'GRID:SET_PREMATCH_ORDER_KEY';
export const SET_PREMATCH_FAVORITES_ORDER_KEY = 'GRID:SET_PREMATCH_FAVORITES_ORDER_KEY';
export const SET_INTERESTING_MATCHES_ORDER_KEY = 'GRID:SET_INTERESTING_MATCHES_ORDER_KEY';


export const setLiveGridStakeTypes = (payload) => ({
  type: SET_LIVE_GRID_STAKE_TYPES,
  payload,
});

export const setPrematchGridStakeTypes = (payload) => ({
  type: SET_PREMATCH_GRID_STAKE_TYPES,
  payload,
});

export const setPrematchFavoritesGridStakeTypes = (payload) => ({
  type: SET_PREMATCH_FAVORITES_GRID_STAKE_TYPES,
  payload,
});

export const setInterestingMatchesGridStakeTypes = (payload) => ({
  type: SET_INTERESTING_MATCHES_GRID_STAKE_TYPES,
  payload,
});

export const setGridOrderKey = (key, namespace) => ({
  type: () => {
    switch (namespace) {
      case namespace === NAMESPACE_LIVE:
        return SET_LIVE_GRID_ORDER_KEY;
      case namespace === NAMESPACE_PREMATCH:
        return SET_PREMATCH_GRID_ORDER_KEY;
      case namespace === NAMESPACE_FAVORITES:
        return SET_PREMATCH_FAVORITES_ORDER_KEY;
      case namespace === NAMESPACE_INTERESTING_MATCHES:
        return SET_INTERESTING_MATCHES_ORDER_KEY;
      default:
        return;
    }
  },
  payload: { key },
});
